var I = /* @__PURE__ */ ((E) => (E[E.ACTIVE = 1] = "ACTIVE", E[E.OUT_OF_RANGE = 2] = "OUT_OF_RANGE", E[E.SUSPENDED = 3] = "SUSPENDED", E[E.NOT_POSSIBLE_TO_DELIVER = 4] = "NOT_POSSIBLE_TO_DELIVER", E[E.INVALID_ADDRESS = 5] = "INVALID_ADDRESS", E[E.INVALID_CONTACT_DATA = 6] = "INVALID_CONTACT_DATA", E[E.LOCATION_TEMPORARILY_UNAVAILABLE = 7] = "LOCATION_TEMPORARILY_UNAVAILABLE", E[E.NO_DRIVERS_AVAILABLE = 8] = "NO_DRIVERS_AVAILABLE", E))(I || {});
export {
  I as AddressValidationStatus
};
//# sourceMappingURL=address-validation-status.enum.js.map
